import { LOG_LEVELS } from "../constants/LogLevels"
import ApiService from "../core/service/ApiService"
import { sendToLogServer } from "../core/service/BusinessLogicService"
import { digitalJourneyApigateway } from "../intances/apigateway"

export function dropDelayOrder(apiUrl, opl, access_token) {
  const API_URL_DROP_DELAY_OFFER = `${apiUrl}api/v2/offers/${opl}/dropping-delay`
  const headers = {
    Authorization: `Bearer ${access_token}`,
    Accept: "*/*"
  }
  return ApiService.getForEvollisApi(API_URL_DROP_DELAY_OFFER, headers)
    .then((data) => {
      return data
    })
    .catch((error) => {
      console.error(error)
    })
}

export function getOfferFileTemplates(tunnelData) {
  const { offerId } = tunnelData.data.order
  const DOCUMENT_CATEGORY = "PRIVACY_CONFIRMATION"
  const API_URL = `middle-business-service/api/v2/offers/${offerId}/templates/${DOCUMENT_CATEGORY}`

  return digitalJourneyApigateway(tunnelData)
    .get(API_URL)
    .then((response) => response.data)
    .catch((error) => {
      sendToLogServer(
        LOG_LEVELS.ERROR,
        `An error occured when retrieving offer document by category, error message => ${error.message}`
      )
      throw error
    })
}
